module.exports = __webpack_public_path__ + "img/video_5.5f7670de.png";